import React, { useState } from 'react';
import FilterCtx from './filterCtx';
import { IFund } from '../../common/services/http/fundsService';
import { IClassification } from '../../common/services/http/documentsService';
import { IInvestor } from '../../common/services/http/investorsService';

const FilterContext = (props) => {
  const [docName, setDocName] = useState('');
  const [typePickerBoard, setTypePickerBoard] = useState(false);
  const [typePickerDocument, setTypePickerDocument] = useState(false);
  const [docNameActivity, setDocNameActivity] = useState('');
  const [publishChecked, setPublishChecked] = useState(false);
  const [effectiveChecked, setEffectiveChecked] = useState(false);
  const [asOfDate, setAsOfDate] = useState('');
  const [period, setPeriod] = useState('');
  const [classifications, setClassifications] = useState<IClassification[]>([]);
  const [classificationsActivity, setClassificationsActivity] = useState<IClassification[]>([]);
  const [investors, setInvestors] = useState<IInvestor[]>([]);
  const [investorsActivity, setInvestorsActivity] = useState<IInvestor[]>([]);
  const [funds, setFunds] = useState<IFund[]>([]);
  const [fundsActivity, setFundsActivity] = useState<IFund[]>([]);
  const [read, setRead] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [activityFeedFromDate, setActivityFeedFromDate] = useState(30);

  const [classificationToggle, setClassificationToggle] = useState<boolean>(false);
  const [fundsToggle, setFundsToggle] = useState<boolean>(false);
  const [investorsToggle, setInvestorsToggle] = useState<boolean>(false);
  const [periodToggle, setPeriodToggle] = useState<boolean>(false);
  const [slicerChoices, setSlicerChoices] = useState([]);

  const [initialGroup, setInitialGroup] = useState<any>([]);

  const clearFilters = () => {
    setDocName('');
    setPublishChecked(false);
    setEffectiveChecked(false);
    setClassifications([]);
    setInvestors([]);
    setFunds([]);
    setRead('');
    setFromDate('');
    setToDate('');
    setPeriod('');
    setClassificationToggle(false);
    setInvestorsToggle(false);
    setFundsToggle(false);
    setPeriodToggle(false);
    setSlicerChoices([]);
    setInitialGroup([]);
  };
  const clearAllFilters = () => {
    clearFiltersActivity();
    clearFilters();
  };

  const clearFiltersActivity = () => {
    setDocNameActivity('');
    setTypePickerBoard(false);
    setTypePickerDocument(false);
    setClassificationsActivity([]);
    setInvestorsActivity([]);
    setFundsActivity([]);
    setActivityFeedFromDate(30);
  };

  const hasFilters = () => {
    return !!(
      docName !== '' ||
      funds.length !== 0 ||
      investors.length !== 0 ||
      classifications.length !== 0 ||
      fromDate ||
      toDate ||
      period ||
      read === 'read' ||
      read === 'unread' ||
      classificationToggle ||
      investorsToggle ||
      fundsToggle ||
      periodToggle
    );
  };

  const hasActivityFilters = () => {
    return !!(
      docNameActivity !== '' ||
      typePickerBoard ||
      typePickerDocument ||
      fundsActivity.length !== 0 ||
      investorsActivity.length !== 0 ||
      classificationsActivity.length !== 0 ||
      activityFeedFromDate !== 30
    );
  };

  // @ts-ignore
  return (
    <FilterCtx.Provider
      value={{
        docName: docName,
        docNameActivity: docNameActivity,
        funds: funds,
        typePickerBoard: typePickerBoard,
        typePickerDocument: typePickerDocument,
        fundsActivity: fundsActivity,
        investors: investors,
        investorsActivity: investorsActivity,
        classifications: classifications,
        classificationsActivity: classificationsActivity,
        read: read,
        publishChecked: publishChecked,
        effectiveChecked: effectiveChecked,
        asOfDate: asOfDate,
        period: period,
        classificationToggle: classificationToggle,
        fundsToggle: fundsToggle,
        investorsToggle: investorsToggle,
        periodToggle: periodToggle,
        slicerChoices: slicerChoices,
        initialGroup: initialGroup,
        activityFeedFromDate: activityFeedFromDate,
        // checkedDocuments: checkedDocuments,
        // @ts-ignore
        setDocName: setDocName,
        setTypePickerBoard: setTypePickerBoard,
        setTypePickerDocument: setTypePickerDocument,
        setDocNameActivity: setDocNameActivity,
        setFunds: setFunds,
        setFundsActivity: setFundsActivity,
        setInvestors: setInvestors,
        setInvestorsActivity: setInvestorsActivity,
        setClassifications: setClassifications,
        setClassificationsActivity: setClassificationsActivity,
        setRead: setRead,
        setPublishChecked: setPublishChecked,
        setEffectiveChecked: setEffectiveChecked,
        setAsOfDate: setAsOfDate,
        setPeriod: setPeriod,
        clearFilters: clearFilters,
        clearFiltersActivity: clearFiltersActivity,
        hasFilters: hasFilters,
        hasActivityFilters: hasActivityFilters,
        setClassificationToggle: setClassificationToggle,
        setFundsToggle: setFundsToggle,
        setInvestorsToggle: setInvestorsToggle,
        setPeriodToggle: setPeriodToggle,
        setSlicerChoices: setSlicerChoices,
        setInitialGroup: setInitialGroup,
        setActivityFeedFromDate: setActivityFeedFromDate,
        fromDate: fromDate,
        setFromDate: setFromDate,
        toDate: toDate,
        setToDate: setToDate,
        clearAllFilters: clearAllFilters,
      }}>
      {props.children}
    </FilterCtx.Provider>
  );
};

export default FilterContext;
